class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* ==========================================================================
   KADA-194 / KADA-215 - header search dialog

   DetailsModal above is left exactly as it was: assets/password-modal.js extends it and
   sections/main-password-header.liquid still renders the <details>/<summary> markup it expects.
   The header search gets its own element so the trigger can be a real <button>.
   ========================================================================== */

class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('[data-search-modal-container]');
    this.toggle = this.querySelector('[data-search-modal-toggle]');
    this.dialog = this.querySelector('[role="dialog"]');
    this.closeButton = this.querySelector('.search-modal__close-button');

    this.toggle?.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.addEventListener('keyup', (event) => event.code?.toUpperCase() === 'ESCAPE' && this.close());
  }

  get isOpen() {
    return this.container?.hasAttribute('open');
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open() {
    if (this.isOpen) return;

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.container.setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // The dialog is opacity:0 until [open] lands. Focus on the next frame so the search input is
    // actually focusable when focus is moved into it.
    requestAnimationFrame(() =>
      trapFocus(
        this.dialog.querySelector('[tabindex="-1"]'),
        this.dialog.querySelector('input:not([type="hidden"])')
      )
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen) return;

    removeTrapFocus(focusToggle ? this.toggle : null);
    this.container.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('search-modal', SearchModal);
